module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "xl-banner"
    }
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xianlaigame.com/#/NewsInfoALY"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/banner_04.jpg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "http://a.app.qq.com/o/simple.jsp?pkgname=com.mahjong.sichuang"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/banner_01.jpg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "http://a.app.qq.com/o/simple.jsp?pkgname=com.xianlai.mahjonghn"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/banner_02.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "http://a.app.qq.com/o/simple.jsp?pkgname=com.xianlai.mahjonggd"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/banner_03.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cccdf24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Banner.vue
// module id = 259
// module chunks = 1